module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-fototeca-carrello",
      "title": "Carrello"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-107ad004!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/FototecaCarrello.vue
// module id = 822
// module chunks = 39